import { useState } from "react";
import { scrollToElement } from "@/utils/GlobalJavascriptFunction";

import stl from "./carDetailsSection.module.css";
import SinglePanel from "./SinglePanel";
import MojazSection from "../MojazSection/MojazSection";
import {useTranslation} from "@i18n";
const CarDetailsSection = ({
  sections,
  carDetails,
  fuelEco,
  mojazData,
  g4_data,
  screen_view_referral,
}) => {
  const { t } = useTranslation(["web_post_view"]);
  const [activePan, setActivePan] = useState(0);

  const setNewPan = (val) => {
    setActivePan(val == activePan ? null : val);
  };
  return (
    <>
      <div className={stl.container}>
        <h2>{t("معلومات السيارة", { ns: "web_post_view" })}</h2>
        <div className={stl.pansContainer}>
          <SinglePanel
            idSep={"00009"}
            key={0}
            isActive={activePan == 0}
            setNewPan={() => {
              setNewPan(0);
              setTimeout(() => {
                scrollToElement(
                  document.querySelector(".scrollTmeMF" + "00009"),
                  -70
                );
              }, 100);
            }}
            has2columns
            title={t("معلومات السيارة", { ns: "web_post_view" })}
            data={carDetails}
            fuelEco={fuelEco}
          />
          {mojazData && (
            <MojazSection
              t={t}
              data={mojazData}
              g4_data={g4_data}
              screen_view_referral={screen_view_referral}
            />
          )}
          {sections?.length > 0 &&
            sections.map((item, idx) => {
              const Sep = idx;
              return (
                <SinglePanel
                  idSep={Sep}
                  hasIdForScroll={idx == 0}
                  key={idx + 1}
                  isActive={activePan == idx + 1}
                  setNewPan={() => {
                    setNewPan(idx + 1);

                    setTimeout(() => {
                      scrollToElement(
                        document.querySelector(".scrollTmeMF" + Sep),
                        -70
                      );
                    }, 100);

                    // document.querySelector("#backToMe").click();
                  }}
                  title={item.category}
                  data={item.data}
                />
              );
            })}
        </div>
      </div>
    </>
  );
};

export default CarDetailsSection;
